// @flow
import * as React from 'react';
import RowActions from 'esm-web-pro/components/layout/sidePanel/RowActions';
import { Box } from 'grommet';
import ContentRow from 'esm-web-pro/components/layout/sidePanel/ContentRow';
import { injectIntl, IntlShape, defineMessages } from 'react-intl';
import points14Messages from 'esm-web-pro/messages/points14Messages';
import { point12Messages } from 'esm-web-pro/messages/points12Messages';
import DisconnectIcon from 'esm-web-pro/components/layout/sidePanel/icons/DisconnectIcon';
import actionMessages from 'esm-web-pro/messages/actionMessages';
import ConnectIcon from 'esm-web-pro/components/layout/sidePanel/icons/ConnectIcon';
import { withRouter } from 'react-router-dom';
import type { RouterHistory, Match } from 'react-router-dom';
import MeatballsIcon from 'esm-web-pro/components/layout/sidePanel/icons/MeatballsIcon';
import { POINT12_CONTENT_TOOLTIP_KEY }
    from 'esm-web-pro/containers/pages/network/objects/point12/CableList/Point12CableList';
import dataPortMessages from 'esm-web-pro/messages/dataPortMessages';
import ValueText from 'esm-web-pro/components/layout/sidePanel/ValueText';

type Props = {
    clickedRowIdentity: string,
    intl: IntlShape,
    port: Object,
    intl: injectIntl,
    parentRowId: string,
    history: RouterHistory,
    match: Match,
    padLevel?: 1 | 2 | 3,
    allowSplicing?: boolean,
    onConnect: Function,
    onDisconnect: Function,
    map: Object,
    point: Object,
    switchPortIndex: Number,
    onClick: Function,
    disablePortDisconnect: boolean,
    loading?: false,
}

const msg = defineMessages({
    disconnectedPort: {
        id: 'optical-port-disconnected',
        defaultMessage: 'Disconnected',
    },
});

const OpticalPortSplicedPortRow = (props: Props) => {
    const {
        clickedRowIdentity, intl: { formatMessage }, port, parentRowId,
        history, match, padLevel, allowSplicing, onConnect, onDisconnect, map: networkMap, point, switchPortIndex,
        onClick, disablePortDisconnect, loading,
    } = props;

    const rowId = `${parentRowId}-port`;

    const getActions = () => {
        if (port) {
            const actions = [{
                key: `${port.uuid}-more`,
                icon: <MeatballsIcon />,
                size: '20px',
                width: '3px',
                callback: (e: SyntheticMouseEvent<HTMLButtonElement>) => {
                    e.stopPropagation();
                    const path = match.url.split('/layer');
                    history.push(`${path[0]}/layer/${port.type}/${port.identity}`);
                },
                tooltip: formatMessage(actionMessages.more),
                tooltipKey: POINT12_CONTENT_TOOLTIP_KEY,
            }];

            if (networkMap.is_draft) {
                actions.splice(0, 0, {
                    key: `${port.uuid}-break`,
                    icon: <DisconnectIcon />,
                    callback: (e: SyntheticMouseEvent<HTMLButtonElement>) => {
                        e.stopPropagation();
                        onDisconnect();
                    },
                    size: '20px',
                    width: '3px',
                    tooltip: formatMessage(actionMessages.disconnect),
                    tooltipKey: POINT12_CONTENT_TOOLTIP_KEY,
                    disabled: disablePortDisconnect || loading,
                    loading,
                });
            }
            return actions;
        }

        if (allowSplicing && networkMap.is_draft) {
            return [
                {
                    key: `${parentRowId}-port-connect`,
                    icon: <ConnectIcon />,
                    callback: (e: SyntheticMouseEvent<HTMLButtonElement>) => {
                        e.stopPropagation();
                        onConnect();
                    },
                    size: '20px',
                    width: '3px',
                    tooltip: formatMessage(actionMessages.connect),
                    tooltipKey: POINT12_CONTENT_TOOLTIP_KEY,
                    disabled: !point.pop_has_free_ports || loading,
                    loading,
                },
            ];
        }
        return [];
    };

    let pointName;
    if (port) {
        // Rack
        pointName = port.container.rack ? `${formatMessage(point12Messages.rack)} ${port.container.rack.sequence}` : '';

        if (port.container.type === 'switch') {
            // Switch name
            pointName += ` - ${port.container.oss_switch_name}`;
            // Data port
            pointName += ` - ${formatMessage(dataPortMessages.short)} ${port.data_port_number}`;
            // Optical Switch port
            pointName += ` - ${formatMessage(points14Messages.opticalSwitchPortShort)} ${port.sequence}`;
        } else {
            // ODF name
            pointName += ` - ${formatMessage(point12Messages[port.container.type])} ${port.container.sequence}`;
            // Optical ODF port
            pointName += ` - ${formatMessage(points14Messages.opticalOdfportShort)} ${port.sequence}`;
        }
    }

    return (
        <ContentRow
            padLevel={padLevel}
            rowId={rowId}
            actions={(
                <RowActions
                    iconPadding="3px"
                    gapBetweenActions="small"
                    actions={getActions()}
                />
            )}
            onClick={onClick}
            clickedRowIdentity={clickedRowIdentity}
        >
            <Box>
                <ValueText>
                    {`${formatMessage(points14Messages.opticalport)} ${switchPortIndex?.toString() || ''}: `}
                    {(port && pointName) ? pointName : formatMessage(msg.disconnectedPort)}
                </ValueText>
            </Box>
        </ContentRow>
    );
};

OpticalPortSplicedPortRow.defaultProps = {
    padLevel: null,
    allowSplicing: true,
    disablePortDisconnect: false,
    loading: false,
};

export default withRouter(injectIntl(OpticalPortSplicedPortRow));
